export default __webpack_public_path__ + "static/media/oral-6.d0be79d9.png";